import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(dona)/lnd/successo/page.jsx");
